import ModelUtil from '@leverege/model-util';
import I18N from '@leverege/i18n';
import { Config } from '@leverege/plugin';
const {
  tf,
  tfIcon
} = I18N.ns('ui-attributes.condition.comparator.type.timestamp.TimestampGreaterThanOrEqualComparator');
const TYPE = 'timestamp.GreaterThanOrEqual';
const valueType = 'timestamp';
function create() {
  return {
    type: TYPE,
    value1: null
  };
}
export default {
  type: TYPE,
  TYPE,
  valueType,
  name: tf('name'),
  layout: () => {
    return Config.get('TimestampGreaterThanOrEqualComparator', 'layout', {
      sort: 'c'
    });
  },
  icon: tfIcon('icon'),
  create,
  ...ModelUtil.createAllValue('value1'),
  takeValuesFrom(model, oldValue) {
    if (oldValue?.value1 != null) {
      return {
        ...model,
        value1: oldValue?.value1
      };
    }
    return model;
  }
};